/**
 * 文字选中引用自定义事件工具
 *
 * 提供跨组件通信的自定义事件功能
 */

import type { TextQuoteEventDetail } from '../types/textSelection';

/** 引用事件名称 */
export const TEXT_QUOTE_EVENT = 'textSelection:quote';

/**
 * 触发文字引用事件
 * @param detail 引用事件详情
 */
export function triggerTextQuote(detail: TextQuoteEventDetail): void {
  window.dispatchEvent(new CustomEvent(TEXT_QUOTE_EVENT, { detail }));
}

/**
 * 监听文字引用事件
 * @param callback 事件回调函数
 * @returns 清理函数
 */
export function onTextQuote(callback: (detail: TextQuoteEventDetail) => void): () => void {
  const handler = (e: Event) => {
    const detail = (e as CustomEvent<TextQuoteEventDetail>).detail;
    callback(detail);
  };

  window.addEventListener(TEXT_QUOTE_EVENT, handler);

  return () => {
    window.removeEventListener(TEXT_QUOTE_EVENT, handler);
  };
}
